<div class="p-4 md:p-6 max-w-3xl mx-auto">

  <!-- Header -->
  <div class="mb-6">
    <h1 class="text-2xl font-bold text-gray-800 flex items-center">
      <mat-icon style="color: #1C593D; margin-right: 8px;">schedule</mat-icon>
      Horario de Operaciones
    </h1>
    <p style="color: #6b7280; font-size: 0.85rem; margin-top: 4px;">
      Gestiona el estado de las operaciones y envíos por canal.
    </p>
  </div>

  <!-- ═══ Sección 1: Estado de Operaciones ═══ -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-5">
    <!-- Header clickable mobile -->
    <div (click)="toggleSection('estado')"
      class="flex items-center justify-between px-4 py-3 md:px-6 md:py-4 cursor-pointer xl:cursor-default"
      [style.background]="expandedSections.has('estado') ? 'linear-gradient(135deg, #f0fdf4, #ecfdf5)' : 'linear-gradient(135deg, #f0fdf4, #ecfdf5)'"
      style="border-bottom: 2px solid #bbf7d0;">
      <div style="display: flex; align-items: center; gap: 10px;">
        <mat-icon style="color: #1C593D; font-size: 24px; width: 24px; height: 24px;">toggle_on</mat-icon>
        <span style="font-size: 1.05rem; font-weight: 700; color: #1e5a3f;">Estado de Operaciones</span>
      </div>
      <mat-icon class="xl:hidden" style="color: #1C593D; transition: transform 0.3s ease;"
        [style.transform]="expandedSections.has('estado') ? 'rotate(180deg)' : 'rotate(0)'">
        expand_more
      </mat-icon>
    </div>

    <!-- Contenido colapsable -->
    <div class="p-4 md:p-6 space-y-3"
      [class.hidden]="!expandedSections.has('estado')"
      [class.xl:block]="true">

      <!-- FIAT -->
      <ng-container *ngIf="role !== 'aguacate_retail_cashier'">
        <div class="operation-row">
          <div class="flex items-center gap-3 flex-1 min-w-0">
            <div class="status-dot" [style.background]="estadoOperacion.FIAT ? '#16a34a' : '#dc2626'"></div>
            <div class="flex flex-col sm:flex-row sm:items-center sm:gap-2">
              <span style="font-weight: 700; font-size: 0.9rem; color: #374151;">FIAT</span>
              <span class="status-badge"
                [style.background]="estadoOperacion.FIAT ? '#f0fdf4' : '#fef2f2'"
                [style.color]="estadoOperacion.FIAT ? '#16a34a' : '#dc2626'"
                [style.border-color]="estadoOperacion.FIAT ? '#bbf7d0' : '#fecaca'">
                {{ estadoOperacion.FIAT ? 'Activa' : 'Cerrada' }}
              </span>
            </div>
          </div>
          <div class="flex gap-2 flex-shrink-0">
            <button type="button" (click)="saveEstadoOperacion(false, 'FIAT')" [disabled]="!estadoOperacion.FIAT"
              [style.opacity]="!estadoOperacion.FIAT ? '0.4' : '1'"
              class="btn-close-op">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px;">block</mat-icon>
              <span class="hidden sm:inline">Cerrar</span>
            </button>
            <button type="button" (click)="saveEstadoOperacion(true, 'FIAT')" [disabled]="estadoOperacion.FIAT"
              [style.opacity]="estadoOperacion.FIAT ? '0.4' : '1'"
              class="btn-activate-op">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px;">check_circle</mat-icon>
              <span class="hidden sm:inline">Activar</span>
            </button>
          </div>
        </div>
      </ng-container>

      <!-- USDT -->
      <ng-container *ngIf="role !== 'aguacate_retail_cashier'">
        <div class="operation-row">
          <div class="flex items-center gap-3 flex-1 min-w-0">
            <div class="status-dot" [style.background]="estadoOperacion.USDT ? '#16a34a' : '#dc2626'"></div>
            <div class="flex flex-col sm:flex-row sm:items-center sm:gap-2">
              <span style="font-weight: 700; font-size: 0.9rem; color: #374151;">USDT</span>
              <span class="status-badge"
                [style.background]="estadoOperacion.USDT ? '#f0fdf4' : '#fef2f2'"
                [style.color]="estadoOperacion.USDT ? '#16a34a' : '#dc2626'"
                [style.border-color]="estadoOperacion.USDT ? '#bbf7d0' : '#fecaca'">
                {{ estadoOperacion.USDT ? 'Activa' : 'Cerrada' }}
              </span>
            </div>
          </div>
          <div class="flex gap-2 flex-shrink-0">
            <button type="button" (click)="saveEstadoOperacion(false, 'USDT')" [disabled]="!estadoOperacion.USDT"
              [style.opacity]="!estadoOperacion.USDT ? '0.4' : '1'"
              class="btn-close-op">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px;">block</mat-icon>
              <span class="hidden sm:inline">Cerrar</span>
            </button>
            <button type="button" (click)="saveEstadoOperacion(true, 'USDT')" [disabled]="estadoOperacion.USDT"
              [style.opacity]="estadoOperacion.USDT ? '0.4' : '1'"
              class="btn-activate-op">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px;">check_circle</mat-icon>
              <span class="hidden sm:inline">Activar</span>
            </button>
          </div>
        </div>
      </ng-container>

      <!-- ZELLE -->
      <ng-container *ngIf="role !== 'aguacate_retail_cashier'">
        <div class="operation-row">
          <div class="flex items-center gap-3 flex-1 min-w-0">
            <div class="status-dot" [style.background]="estadoOperacion.ZELLE ? '#16a34a' : '#dc2626'"></div>
            <div class="flex flex-col sm:flex-row sm:items-center sm:gap-2">
              <span style="font-weight: 700; font-size: 0.9rem; color: #374151;">ZELLE</span>
              <span class="status-badge"
                [style.background]="estadoOperacion.ZELLE ? '#f0fdf4' : '#fef2f2'"
                [style.color]="estadoOperacion.ZELLE ? '#16a34a' : '#dc2626'"
                [style.border-color]="estadoOperacion.ZELLE ? '#bbf7d0' : '#fecaca'">
                {{ estadoOperacion.ZELLE ? 'Activa' : 'Cerrada' }}
              </span>
            </div>
          </div>
          <div class="flex gap-2 flex-shrink-0">
            <button type="button" (click)="saveEstadoOperacion(false, 'ZELLE')" [disabled]="!estadoOperacion.ZELLE"
              [style.opacity]="!estadoOperacion.ZELLE ? '0.4' : '1'"
              class="btn-close-op">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px;">block</mat-icon>
              <span class="hidden sm:inline">Cerrar</span>
            </button>
            <button type="button" (click)="saveEstadoOperacion(true, 'ZELLE')" [disabled]="estadoOperacion.ZELLE"
              [style.opacity]="estadoOperacion.ZELLE ? '0.4' : '1'"
              class="btn-activate-op">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px;">check_circle</mat-icon>
              <span class="hidden sm:inline">Activar</span>
            </button>
          </div>
        </div>
      </ng-container>

      <!-- Envío Binance: se movió a "Binance y redes cripto" -->

      <!-- Pago Móvil Global -->
      <ng-container *ngIf="role !== 'aguacate_retail_cashier'">
        <div class="operation-row">
          <div class="flex items-center gap-3 flex-1 min-w-0">
            <div class="status-dot" [style.background]="pagoMovilGlobal ? '#16a34a' : '#dc2626'"></div>
            <div class="flex flex-col sm:flex-row sm:items-center sm:gap-2">
              <span style="font-weight: 700; font-size: 0.9rem; color: #374151;">Pago Móvil Global</span>
              <span class="status-badge"
                [style.background]="pagoMovilGlobal ? '#f0fdf4' : '#fef2f2'"
                [style.color]="pagoMovilGlobal ? '#16a34a' : '#dc2626'"
                [style.border-color]="pagoMovilGlobal ? '#bbf7d0' : '#fecaca'">
                {{ pagoMovilGlobal ? 'Activo' : 'Cerrado' }}
              </span>
            </div>
          </div>
          <div class="flex gap-2 flex-shrink-0">
            <button type="button" (click)="savePagoMovilGlobal(0)" [disabled]="!pagoMovilGlobal"
              [style.opacity]="!pagoMovilGlobal ? '0.4' : '1'"
              class="btn-close-op">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px;">block</mat-icon>
              <span class="hidden sm:inline">Cerrar</span>
            </button>
            <button type="button" (click)="savePagoMovilGlobal(1)" [disabled]="pagoMovilGlobal"
              [style.opacity]="pagoMovilGlobal ? '0.4' : '1'"
              class="btn-activate-op">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px;">check_circle</mat-icon>
              <span class="hidden sm:inline">Activar</span>
            </button>
          </div>
        </div>
      </ng-container>

      <!-- Pago Móvil Banesco -->
      <ng-container *ngIf="role !== 'aguacate_retail_cashier'">
        <div class="operation-row">
          <div class="flex items-center gap-3 flex-1 min-w-0">
            <div class="status-dot" [style.background]="pagoMovilBanesco ? '#16a34a' : '#dc2626'"></div>
            <div class="flex flex-col sm:flex-row sm:items-center sm:gap-2">
              <span style="font-weight: 700; font-size: 0.9rem; color: #374151;">Pago Móvil Banesco</span>
              <span class="status-badge"
                [style.background]="pagoMovilBanesco ? '#f0fdf4' : '#fef2f2'"
                [style.color]="pagoMovilBanesco ? '#16a34a' : '#dc2626'"
                [style.border-color]="pagoMovilBanesco ? '#bbf7d0' : '#fecaca'">
                {{ pagoMovilBanesco ? 'Activo' : 'Cerrado' }}
              </span>
            </div>
          </div>
          <div class="flex gap-2 flex-shrink-0">
            <button type="button" (click)="savePagoMovilBanesco(0)" [disabled]="!pagoMovilBanesco"
              [style.opacity]="!pagoMovilBanesco ? '0.4' : '1'"
              class="btn-close-op">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px;">block</mat-icon>
              <span class="hidden sm:inline">Cerrar</span>
            </button>
            <button type="button" (click)="savePagoMovilBanesco(1)" [disabled]="pagoMovilBanesco"
              [style.opacity]="pagoMovilBanesco ? '0.4' : '1'"
              class="btn-activate-op">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px;">check_circle</mat-icon>
              <span class="hidden sm:inline">Activar</span>
            </button>
          </div>
        </div>
      </ng-container>

      <!-- DETAL (AC) -->
      <div class="operation-row">
        <div class="flex items-center gap-3 flex-1 min-w-0">
          <div class="status-dot" [style.background]="estadoOperacion.AC ? '#16a34a' : '#dc2626'"></div>
          <div class="flex flex-col sm:flex-row sm:items-center sm:gap-2">
            <span style="font-weight: 700; font-size: 0.9rem; color: #374151;">DETAL</span>
            <span class="status-badge"
              [style.background]="estadoOperacion.AC ? '#f0fdf4' : '#fef2f2'"
              [style.color]="estadoOperacion.AC ? '#16a34a' : '#dc2626'"
              [style.border-color]="estadoOperacion.AC ? '#bbf7d0' : '#fecaca'">
              {{ estadoOperacion.AC ? 'Activo' : 'Cerrado' }}
            </span>
          </div>
        </div>
        <div class="flex gap-2 flex-shrink-0">
          <button type="button" (click)="saveEstadoOperacion(false, 'AC')" [disabled]="!estadoOperacion.AC"
            [style.opacity]="!estadoOperacion.AC ? '0.4' : '1'"
            class="btn-close-op">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">block</mat-icon>
            <span class="hidden sm:inline">Cerrar</span>
          </button>
          <button type="button" (click)="saveEstadoOperacion(true, 'AC')" [disabled]="estadoOperacion.AC"
            [style.opacity]="estadoOperacion.AC ? '0.4' : '1'"
            class="btn-activate-op">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">check_circle</mat-icon>
            <span class="hidden sm:inline">Activar</span>
          </button>
        </div>
      </div>

    </div>
  </div>

  <!--
    ═══ Sección: Binance y redes cripto ═══
    Lo que decide por dónde y cómo sale lo cripto, junto: el envío automático
    a Binance (antes estaba entre las operaciones) y cada red de los
    beneficiarios cripto. Las redes no son un horario: pausarla corta las
    altas y las transacciones nuevas en esa red, nada más.
  -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-5" *ngIf="role !== 'aguacate_retail_cashier'">
    <!-- Header clickable mobile -->
    <div (click)="toggleSection('cripto')"
      class="flex items-center justify-between px-4 py-3 md:px-6 md:py-4 cursor-pointer xl:cursor-default"
      style="background: linear-gradient(135deg, #fffbeb, #fef3c7); border-bottom: 2px solid #fde68a;">
      <div style="display: flex; align-items: center; gap: 10px;">
        <mat-icon style="color: #b45309; font-size: 24px; width: 24px; height: 24px;">currency_bitcoin</mat-icon>
        <span style="font-size: 1.05rem; font-weight: 700; color: #92400e;">Binance y redes cripto</span>
      </div>
      <mat-icon class="xl:hidden" style="color: #92400e; transition: transform 0.3s ease;"
        [style.transform]="expandedSections.has('cripto') ? 'rotate(180deg)' : 'rotate(0)'">
        expand_more
      </mat-icon>
    </div>

    <!-- Contenido colapsable -->
    <div class="p-4 md:p-6 space-y-3"
      [class.hidden]="!expandedSections.has('cripto')"
      [class.xl:block]="true">

      <p class="section-help">
        <strong>Envío Binance</strong> decide si las transacciones TRC20 salen solas por Binance.
        Cada <strong>red</strong> decide si los clientes pueden dar de alta beneficiarios y crear
        transacciones en ella; lo que ya está creado sigue su curso.
      </p>

      <!-- Envío Binance (movido desde "Estado de Operaciones", misma lógica) -->
      <div class="operation-row">
        <div class="flex items-center gap-3 flex-1 min-w-0">
          <div class="status-dot" [style.background]="estadoBinance ? '#16a34a' : '#dc2626'"></div>
          <div class="flex flex-col sm:flex-row sm:items-center sm:gap-2">
            <span style="font-weight: 700; font-size: 0.9rem; color: #374151;">Envío Binance</span>
            <span class="status-badge"
              [style.background]="estadoBinance ? '#f0fdf4' : '#fef2f2'"
              [style.color]="estadoBinance ? '#16a34a' : '#dc2626'"
              [style.border-color]="estadoBinance ? '#bbf7d0' : '#fecaca'">
              {{ estadoBinance ? 'Activo' : 'Cerrado' }}
            </span>
          </div>
        </div>
        <div class="flex gap-2 flex-shrink-0">
          <button type="button" (click)="saveEstadoBinance(0)" [disabled]="!estadoBinance"
            [style.opacity]="!estadoBinance ? '0.4' : '1'"
            class="btn-close-op">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">block</mat-icon>
            <span class="hidden sm:inline">Cerrar</span>
          </button>
          <button type="button" (click)="saveEstadoBinance(1)" [disabled]="estadoBinance"
            [style.opacity]="estadoBinance ? '0.4' : '1'"
            class="btn-activate-op">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">check_circle</mat-icon>
            <span class="hidden sm:inline">Activar</span>
          </button>
        </div>
      </div>

      <!-- Redes: cargando -->
      <div *ngIf="!redesCripto && !errorRedes" class="operation-row" style="justify-content: flex-start;">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #9ca3af;">hourglass_empty</mat-icon>
        <span style="font-size: 0.85rem; color: #6b7280;">Cargando el estado de las redes…</span>
      </div>

      <!-- Redes: no se pudo leer. Sin estado real no se ofrecen los botones. -->
      <div *ngIf="errorRedes" class="operation-row" style="border-color: #fecaca; background: #fef2f2;">
        <div class="flex items-center gap-3 flex-1 min-w-0">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #dc2626; flex-shrink: 0;">error_outline</mat-icon>
          <span style="font-size: 0.85rem; color: #991b1b;">No pudimos leer el estado de las redes cripto.</span>
        </div>
        <button type="button" (click)="cargarRedes()" class="btn-activate-op">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px;">refresh</mat-icon>
          <span class="hidden sm:inline">Reintentar</span>
        </button>
      </div>

      <!-- Una tarjeta por red -->
      <div *ngFor="let red of redesCripto" class="operation-row">
        <div class="flex items-center gap-3 flex-1 min-w-0">
          <div class="status-dot" [style.background]="red.activo ? '#16a34a' : '#f59e0b'"></div>
          <div class="flex flex-col min-w-0">
            <div class="flex flex-col sm:flex-row sm:items-center sm:gap-2">
              <span style="font-weight: 700; font-size: 0.9rem; color: #374151;">Red {{ nombreRed(red) }}</span>
              <span class="status-badge"
                [style.background]="red.activo ? '#f0fdf4' : '#fefce8'"
                [style.color]="red.activo ? '#16a34a' : '#ca8a04'"
                [style.border-color]="red.activo ? '#bbf7d0' : '#fde68a'">
                {{ red.activo ? 'Activa' : 'Pausada' }}
              </span>
              <span class="pago-tag" [class.pago-binance]="red.pagaBinance"
                [title]="red.pagaBinance ? 'Las transacciones de esta red las envía Binance' : 'Binance no paga esta red: las transacciones quedan en POR_PROCESAR para un operador'">
                {{ red.pagaBinance ? 'La paga Binance' : 'Pago manual' }}
              </span>
            </div>
            <span *ngIf="red.actualizadoPor || red.actualizadoEn" class="ultimo-cambio">
              Último cambio: {{ red.actualizadoPor || 'sin registro' }}<ng-container *ngIf="red.actualizadoEn"> · {{ red.actualizadoEn | date: 'dd/MM/yyyy HH:mm' }}</ng-container>
            </span>
          </div>
        </div>
        <div class="flex gap-2 flex-shrink-0">
          <button type="button" (click)="cambiarEstadoRed(red, false)" [disabled]="!red.activo"
            [style.opacity]="!red.activo ? '0.4' : '1'"
            class="btn-pause-op">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">pause</mat-icon>
            <span class="hidden sm:inline">Pausar</span>
          </button>
          <button type="button" (click)="cambiarEstadoRed(red, true)" [disabled]="red.activo"
            [style.opacity]="red.activo ? '0.4' : '1'"
            class="btn-activate-op">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">play_arrow</mat-icon>
            <span class="hidden sm:inline">Activar</span>
          </button>
        </div>
      </div>

    </div>
  </div>

  <!-- ═══ Sección 2: Stop de operaciones ═══ -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-5" *ngIf="role !== 'aguacate_retail_cashier'">
    <!-- Header clickable mobile -->
    <div (click)="toggleSection('stop')"
      class="flex items-center justify-between px-4 py-3 md:px-6 md:py-4 cursor-pointer xl:cursor-default"
      style="background: linear-gradient(135deg, #fef2f2, #fee2e2); border-bottom: 2px solid #fecaca;">
      <div style="display: flex; align-items: center; gap: 10px;">
        <mat-icon style="color: #dc2626; font-size: 24px; width: 24px; height: 24px;">pause_circle</mat-icon>
        <span style="font-size: 1.05rem; font-weight: 700; color: #991b1b;">Stop de Operaciones</span>
      </div>
      <mat-icon class="xl:hidden" style="color: #991b1b; transition: transform 0.3s ease;"
        [style.transform]="expandedSections.has('stop') ? 'rotate(180deg)' : 'rotate(0)'">
        expand_more
      </mat-icon>
    </div>

    <!-- Contenido colapsable -->
    <div class="p-4 md:p-6 space-y-3"
      [class.hidden]="!expandedSections.has('stop')"
      [class.xl:block]="true">

      <!-- FIAT STOP -->
      <div class="operation-row">
        <div class="flex items-center gap-3 flex-1 min-w-0">
          <div class="status-dot" [style.background]="estadoOperacion.FIAT_STOP ? '#16a34a' : '#f59e0b'"></div>
          <div class="flex flex-col sm:flex-row sm:items-center sm:gap-2">
            <span style="font-weight: 700; font-size: 0.9rem; color: #374151;">FIAT</span>
            <span class="status-badge"
              [style.background]="estadoOperacion.FIAT_STOP ? '#f0fdf4' : '#fefce8'"
              [style.color]="estadoOperacion.FIAT_STOP ? '#16a34a' : '#ca8a04'"
              [style.border-color]="estadoOperacion.FIAT_STOP ? '#bbf7d0' : '#fde68a'">
              {{ estadoOperacion.FIAT_STOP ? 'Activa' : 'Pausada' }}
            </span>
          </div>
        </div>
        <div class="flex gap-2 flex-shrink-0">
          <button type="button" (click)="saveEstadoOperacion(false, 'FIAT_STOP')" [disabled]="!estadoOperacion.FIAT_STOP"
            [style.opacity]="!estadoOperacion.FIAT_STOP ? '0.4' : '1'"
            class="btn-pause-op">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">pause</mat-icon>
            <span class="hidden sm:inline">Pausar</span>
          </button>
          <button type="button" (click)="saveEstadoOperacion(true, 'FIAT_STOP')" [disabled]="estadoOperacion.FIAT_STOP"
            [style.opacity]="estadoOperacion.FIAT_STOP ? '0.4' : '1'"
            class="btn-activate-op">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">play_arrow</mat-icon>
            <span class="hidden sm:inline">Reanudar</span>
          </button>
        </div>
      </div>

      <!-- USDT STOP -->
      <div class="operation-row">
        <div class="flex items-center gap-3 flex-1 min-w-0">
          <div class="status-dot" [style.background]="estadoOperacion.USDT_STOP ? '#16a34a' : '#f59e0b'"></div>
          <div class="flex flex-col sm:flex-row sm:items-center sm:gap-2">
            <span style="font-weight: 700; font-size: 0.9rem; color: #374151;">USDT</span>
            <span class="status-badge"
              [style.background]="estadoOperacion.USDT_STOP ? '#f0fdf4' : '#fefce8'"
              [style.color]="estadoOperacion.USDT_STOP ? '#16a34a' : '#ca8a04'"
              [style.border-color]="estadoOperacion.USDT_STOP ? '#bbf7d0' : '#fde68a'">
              {{ estadoOperacion.USDT_STOP ? 'Activa' : 'Pausada' }}
            </span>
          </div>
        </div>
        <div class="flex gap-2 flex-shrink-0">
          <button type="button" (click)="saveEstadoOperacion(false, 'USDT_STOP')" [disabled]="!estadoOperacion.USDT_STOP"
            [style.opacity]="!estadoOperacion.USDT_STOP ? '0.4' : '1'"
            class="btn-pause-op">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">pause</mat-icon>
            <span class="hidden sm:inline">Pausar</span>
          </button>
          <button type="button" (click)="saveEstadoOperacion(true, 'USDT_STOP')" [disabled]="estadoOperacion.USDT_STOP"
            [style.opacity]="estadoOperacion.USDT_STOP ? '0.4' : '1'"
            class="btn-activate-op">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">play_arrow</mat-icon>
            <span class="hidden sm:inline">Reanudar</span>
          </button>
        </div>
      </div>

      <!-- ZELLE STOP -->
      <div class="operation-row">
        <div class="flex items-center gap-3 flex-1 min-w-0">
          <div class="status-dot" [style.background]="estadoOperacion.ZELLE_STOP ? '#16a34a' : '#f59e0b'"></div>
          <div class="flex flex-col sm:flex-row sm:items-center sm:gap-2">
            <span style="font-weight: 700; font-size: 0.9rem; color: #374151;">ZELLE</span>
            <span class="status-badge"
              [style.background]="estadoOperacion.ZELLE_STOP ? '#f0fdf4' : '#fefce8'"
              [style.color]="estadoOperacion.ZELLE_STOP ? '#16a34a' : '#ca8a04'"
              [style.border-color]="estadoOperacion.ZELLE_STOP ? '#bbf7d0' : '#fde68a'">
              {{ estadoOperacion.ZELLE_STOP ? 'Activa' : 'Pausada' }}
            </span>
          </div>
        </div>
        <div class="flex gap-2 flex-shrink-0">
          <button type="button" (click)="saveEstadoOperacion(false, 'ZELLE_STOP')" [disabled]="!estadoOperacion.ZELLE_STOP"
            [style.opacity]="!estadoOperacion.ZELLE_STOP ? '0.4' : '1'"
            class="btn-pause-op">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">pause</mat-icon>
            <span class="hidden sm:inline">Pausar</span>
          </button>
          <button type="button" (click)="saveEstadoOperacion(true, 'ZELLE_STOP')" [disabled]="estadoOperacion.ZELLE_STOP"
            [style.opacity]="estadoOperacion.ZELLE_STOP ? '0.4' : '1'"
            class="btn-activate-op">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">play_arrow</mat-icon>
            <span class="hidden sm:inline">Reanudar</span>
          </button>
        </div>
      </div>

    </div>
  </div>

</div>
